import React, { useEffect, useState } from "react";

const ExtraitTable = ({ data, banqueAccountInfo }) => {
  const [image, setImage] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);

  useEffect(() => {
    // Initialize all items as selected
    if (Array.isArray(data?.success?.factures)) {
      setSelectedItems(data.success.factures.map(() => true));
    }
  }, [data]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      if (!image) {
        const fileUrl = localStorage.getItem("fileUrl");
        if (fileUrl) {
          setImage(fileUrl);
          clearInterval(intervalId);
        }
      }
    }, 100);

    return () => clearInterval(intervalId);
  }, [image]);

  function formatDateToReadable(dateString) {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  }

  const handleCheckboxChange = (index) => {
    const updatedSelection = [...selectedItems];
    updatedSelection[index] = !updatedSelection[index];
    setSelectedItems(updatedSelection);
  };

  const handlePrint = () => {
    const divToPrint = document.getElementById("payements");
    if (!divToPrint) {
      console.error("Element with id 'payements' not found.");
      return;
    }

    // Filter items that are selected
    // const selectedFactures = data?.payements?.filter(
    //   (_, index) => selectedItems[index]
    // );

    const printableContent = `
<html>
    <head>
        <title>Extrait de Compte Bancaire</title>
        <style>
            body {
                font-family: Arial, sans-serif;
                padding: 10px;
            }
            h3 {
                text-align: center;
                margin-bottom: 5px;
            }
            table {
                width: 100%;
                border-collapse: collapse;
                margin-top: 5px;
                text-align: left;
            }
            th, td {
                border: 1px solid black;
                padding: 5px;
            }
            #date{
                width:100px;
            }

           
        </style>
    </head>
    <body>
        <h3>
           Extrait de Compte Bancaire
        </h3>

         <p> RIB :${banqueAccountInfo.rib}</p>
                      <p>Compte :${banqueAccountInfo.name}</p>
                      <p>Adresse :${banqueAccountInfo.agenceLocalisation}</p>
                      <p>Solde actuel :${banqueAccountInfo.solde}</p>
        <table>
            <thead>
                <tr> 
                    <th id="date">Date</th>
                    <th>Libellé</th>
                    <th>Référence</th>
                    <th>Valeur</th>
                    <th>Débit</th>
                    <th>Crédit</th>
                </tr>
            </thead>
            <tbody>
             <td colSpan="6" style={{ border: "1px solid black", padding: "10px" }}>
                    solde au   ${formatDateToReadable(data?.dateSoldeInit)}: ${data.soldeInit}
                   
                  </td>
                ${data?.payements
        ?.map(
          (item) => `
                    <tr>

                    
                    
                        <td id="date">${formatDateToReadable(
            item.creationDate
          )}</td>
                        <td>${item.refOperation || "-"}</td>
                        <td>${RefPayementFormatterImpression(item) || "-"}</td>
                        <td>${formatDateToReadable(item.operationDate) || "0.00"}</td>
                        <td>${(item.type === 1 && item.amountPayed) || "-"}</td>
                        <td>${(item.type === 0 && item.amountPayed) || "-"}</td>
                    </tr>
                `
        )
        .join("") || ""
      }
                <tr>
                    <td colspan="4" style="font-weight: bold;">Total</td>
                    <td colspan="1">${data.total1.toFixed(3) || "0.000"}</td>
                    <td colspan="1">${data.total0.toFixed(3) || "0.000"}</td>
                </tr>
                 <td colSpan="6" style={{ border: "1px solid black", padding: "10px" }}>
                    solde au   ${formatDateToReadable(data.dateSoldeActuel)}: ${data.soldeActuel}
                   
                  </td>
            </tbody>
        </table>
    </body>
</html>`;

    const newWin = window.open("", "PrintWindow", "width=800,height=600");
    newWin.document.write(printableContent);
    setTimeout(() => {
      newWin.print();
      newWin.close();
    }, 1000);
  };



  function RefPayementFormatter(item) {
    console.log("item", item);

    if (item.typePayement === "Espéce") {
      return (
        <span >
          Espèce: {item.ref}-{item.year}
        </span>
      );
    } else if (item.typePayement === "Virement") {
      return (
        <span >
          Virement: {item.numVirement}
        </span>
      );
    }
    else if (item.typePayement === "Chéque / Traites") {
      return (
        <span >
          Chéque / Traites: {item.codeCheque}
        </span>
      );
    }
    else if (item.typePayement === "En ligne") {
      return (
        <span >
          TPE: {item.ref}
        </span>
      );
    }


  }

   function RefPayementFormatterImpression(item) {
    console.log("item", item);

    let ref="";
    if (item.typePayement === "Espéce") {
      ref = "Espèce:"+ item.ref+"-"+item.year;
      
    } else if (item.typePayement === "Virement") {
      ref = "Virement:"+ item.numVirement;
    }
    else if (item.typePayement === "Chéque / Traites") {
      ref="Chéque / Traites:" +item.codeCheque;
    }
    else if (item.typePayement === "En ligne") {
      
       
         ref="TPE:"+ item.ref;
     
    }
    return ref;
  }

  return (
    <div style={{ padding: "20px", fontFamily: "Arial, sans-serif" }}>
      <div id="payements">
        {/* Header Section */}
        <h3 style={{ textAlign: "center", marginBottom: "10px" }}>
          Extrait Bancaire{" "}
          {/* {statusFacture === "1" ? "Payée" : "Non Payée"} de :{" "} */}
          {/* {data?.success?.client?.libelle} */}
        </h3>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: "20px",
            textAlign: "left",
          }}
        >
          <thead>
            <tr>

              <th style={{ border: "1px solid black", padding: "10px" }}>
                Date
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Libellé
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Référence
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Valeur
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Débit
              </th>
              <th style={{ border: "1px solid black", padding: "10px" }}>
                Crédit
              </th>
            </tr>
          </thead>
          <tbody>
            <tr >
              <td colSpan="7" style={{ border: "1px solid black", padding: "10px" }}>
                solde au   {formatDateToReadable(data?.dateSoldeInit)}: {data.soldeInit}

              </td>


            </tr>
            {Array.isArray(data?.payements) &&
              data.payements.map((item, index) => (
                <tr key={index}>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {formatDateToReadable(item.creationDate)}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.refOperation}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {RefPayementFormatter(item)}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {formatDateToReadable(item.operationDate)}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.type === 1 && item.amountPayed}
                  </td>
                  <td style={{ border: "1px solid black", padding: "10px" }}>
                    {item.type === 0 && item.amountPayed}
                  </td>

                </tr>
              ))}

            <tr>
              <td
                colSpan="3"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                Total
              </td>
              <td
                colSpan="2"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                {data.total1.toFixed(3)}
              </td>
              <td
                colSpan="2"
                style={{
                  border: "1px solid black",
                  padding: "10px",
                  fontWeight: "bold",
                }}
              >
                {data.total0.toFixed(3)}
              </td>
            </tr>
            <td colSpan="7" style={{ border: "1px solid black", padding: "10px" }}>
              solde au   {formatDateToReadable(data.dateSoldeActuel)}: {data.soldeActuel}

            </td>
          </tbody>
        </table>
      </div>
      <div className="card-footer">
        <button className="btn btn-dark float-right" onClick={handlePrint}>
          Imprimer
        </button>
      </div>
    </div>
  );
};

export default ExtraitTable;
